import { ReactComponent as CloseSvg } from "../../assets/icons/close.svg";
import { useLockBodyScroll } from "../../hooks/useLockBodyScroll";
import Modal from "../utils/Modal/Modal";
import { useState, useEffect } from "react";
import {
  ModalContainer,
  CloseButton,
  ModalContent,
  ModalTitle,
  ButtonGroup,
  ConfirmButton,
  Row,
  CancelButton,
  Label,
  Input,
  InputContainer,
} from "./EditOrDeleteFolderModal.styles";

const EditOrDeleteFolderModal = ({
  isOpen,
  onClose,
  onConfirm,
  onEdit,
  selectedFolder,
  isLoading = false,
  isEditLoading = false,
}) => {
  useLockBodyScroll(isOpen);

  const [mode, setMode] = useState("edit");
  const [folderName, setFolderName] = useState("");

  useEffect(() => {
    if (isOpen && selectedFolder) {
      setFolderName(selectedFolder.name);
      setMode("edit");
    }
  }, [isOpen, selectedFolder]);

  const handleConfirm = () => {
    if (mode === "delete") {
      onConfirm();
    } else {
      if (folderName.trim() && folderName !== selectedFolder?.name) {
        onEdit({ folderId: selectedFolder._id, name: folderName.trim() });
      }
    }
  };

  const handleCancel = () => {
    if (!isLoading && !isEditLoading) {
      setMode("edit");
      setFolderName(selectedFolder?.name || "");
      onClose();
    }
  };

  const isConfirmDisabled =
    (mode === "delete" && isLoading) ||
    (mode === "edit" &&
      (isEditLoading ||
        !folderName.trim() ||
        folderName === selectedFolder?.name));

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      customOverlayStyles={{ zIndex: 3100 }}
    >
      <ModalContainer>
        <ModalContent>
          <Row>
            <ModalTitle>
              {mode === "delete" ? "Delete Folder" : "Edit Folder"}
            </ModalTitle>
            <CloseButton onClick={handleCancel}>
              <CloseSvg width={20} height={20} />
            </CloseButton>
          </Row>

          {mode === "delete" ? (
            <Label style={{ margin: "1rem 0rem" }}>
              Are you sure you want to delete the folder{" "}
              <strong>{selectedFolder?.name ?? ""}</strong>?
            </Label>
          ) : (
            <InputContainer>
              <Label>Folder Name</Label>
              <Input
                type="text"
                placeholder="Enter folder name"
                value={folderName}
                onChange={(e) => setFolderName(e.target.value)}
                maxLength={50}
                disabled={isEditLoading}
              />
            </InputContainer>
          )}

          <ButtonGroup>
            {mode === "delete" ? (
              <>
                <CancelButton
                  onClick={() => setMode("edit")}
                  disabled={isLoading}
                >
                  Edit
                </CancelButton>
                <ConfirmButton
                  onClick={handleConfirm}
                  $type="danger"
                  disabled={isLoading}
                >
                  {isLoading ? "Deleting..." : "Delete"}
                </ConfirmButton>
              </>
            ) : (
              <>
                <CancelButton
                  onClick={() => setMode("delete")}
                  disabled={isEditLoading}
                >
                  Delete
                </CancelButton>
                <ConfirmButton
                  onClick={handleConfirm}
                  $type="primary"
                  disabled={isConfirmDisabled}
                >
                  {isEditLoading ? "Saving..." : "Save"}
                </ConfirmButton>
              </>
            )}
          </ButtonGroup>
        </ModalContent>
      </ModalContainer>
    </Modal>
  );
};

export default EditOrDeleteFolderModal;
